<template>
  <a-drawer width="60%" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left"><b>{{ formTitle }}</b></a-divider>
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item :label="$t('云种植监控.设备号')" prop="deviceNo">
        <a-input v-model="form.deviceNo" :maxLength="100" />
      </a-form-model-item>
      <a-form-model-item :label="$t('云种植监控.位置名称')" prop="deviceName">
        <a-input v-model="form.deviceName" :maxLength="100" />
      </a-form-model-item>
      <a-form-model-item :label="$t('云种植监控.拉流地址')" prop="videoUrl">
        <a-input v-model="form.videoUrl" :maxLength="1000" />
      </a-form-model-item>
      <a-form-model-item :label="$t('云种植监控.所属气候')" prop="climateId">
        <a-select v-model="form.climateId">
          <a-select-option v-for="item in climateList" :value="item.id" :key="item.id">{{ item.climateName }}</a-select-option>
        </a-select>
      </a-form-model-item>
<!--      <a-form-model-item :label="$t('云种植监控.状态')" prop="status">-->
<!--        <a-radio-group v-model="form.status">-->
<!--          <a-radio v-for="(item, index) in customDict.OnOffEnum" :key="index" :value="item.type">{{ item.name }}</a-radio>-->
<!--        </a-radio-group>-->
<!--      </a-form-model-item>-->
      <a-form-model-item :label="$t('云种植监控.排序')" prop="sort">
        <a-input-number v-model="form.sort" :min="0" :max="9999" style="width: 200px" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">{{ $t('通用.按钮.保存') }}</a-button>
          <a-button @click="cancel">{{ $t('通用.按钮.取消') }}</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getMonitor, addMonitor, updateMonitor } from '@/api/cloudplant/monitor'
import { listClimate } from '@/api/cloudplant/climate'
import { mapGetters } from 'vuex'

export default {
  name: 'CreateForm',
  data() {
    return {
      labelCol: { span: 4 }, wrapperCol: { span: 16 }, submitLoading: false, formTitle: '', open: false, formType: 1, climateList: [],
      form: { id: null, deviceNo: null, deviceName: null, videoUrl: null, climateId: undefined, status: 1, sort: 0 },
      rules: {
        deviceNo: [{ required: true, message: this.$t('云种植监控.设备号') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        deviceName: [{ required: true, message: this.$t('云种植监控.位置名称') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        // videoUrl: [{ required: true, message: this.$t('云种植监控.拉流地址') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        climateId: [{ required: true, message: this.$t('云种植监控.所属气候') + this.$t('通用.文本.不能为空'), trigger: 'change' }]
      }
    }
  },
  computed: { ...mapGetters(['customDict']) },
  created() { this.getClimateList() },
  methods: {
    getClimateList() { listClimate({}).then(response => { this.climateList = response.data }) },
    onClose() { this.open = false; this.reset() },
    cancel() { this.open = false; this.reset() },
    reset() { this.formType = 1; this.form = { id: null, deviceNo: null, deviceName: null, videoUrl: null, climateId: undefined, status: 1, sort: 0 } },
    handleAdd() { this.reset(); this.formType = 1; this.open = true; this.formTitle = this.$t('通用.文本.添加') },
    handleUpdate(row) {
      this.reset(); this.formType = 2
      getMonitor({ id: row.id }).then(response => { this.form = response.data; this.open = true; this.formTitle = this.$t('通用.文本.修改') })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id) {
            updateMonitor(this.form).then(() => { this.$message.success(this.$t('通用.文本.修改成功')); this.open = false; this.$emit('ok') }).finally(() => { this.submitLoading = false })
          } else {
            addMonitor(this.form).then(() => { this.$message.success(this.$t('通用.文本.新增成功')); this.open = false; this.$emit('ok') }).finally(() => { this.submitLoading = false })
          }
        }
      })
    }
  }
}
</script>
